// Resolves an image/file URL to an absolute one usable in <img src> tags.
// Stored images may be one of:
//   - Relative path:        "/api/files/asis-hotels/hotels/abc.jpeg"  → prepend current BACKEND_URL
//   - Old absolute URL with preview/legacy domain → swap host to current BACKEND_URL (so prod doesn't depend on preview)
//   - Foreign absolute URL (unsplash, etc.)        → return as-is
//   - Empty/falsy                                  → return ""

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const resolveImageUrl = (url) => {
    if (!url) return "";
    const u = String(url).trim();
    if (!u) return "";
    // Relative path → prepend current backend
    if (u.startsWith("/")) return `${BACKEND_URL}${u}`;
    // Absolute URL that points to our /api/files endpoint on some (possibly old) host
    const idx = u.indexOf("/api/files/");
    if (idx >= 0) {
        const path = u.slice(idx); // "/api/files/..."
        return `${BACKEND_URL}${path}`;
    }
    // Foreign URL (unsplash, customer-assets, etc.) → return as-is
    return u;
};

export default resolveImageUrl;
